module.exports = __webpack_public_path__ + "media/images/emblems/Daenikon-blazon-61d5c0219c7e2201082ec8185933c496.svg";